import { HttpClient } from '@angular/common/http';
import { Input, Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalVariables } from '../../../../global-variables';
import { UserInfoService } from 'src/app/services/user-info.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { LoginService } from '../login/login.service';


@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  public userFullName: string = '';
  public loginResponse: any;
  public userData: any;

  public email: string = '';
  public password: string = '';

  submitted = false;
  loginForm: FormGroup;

  get f() { return this.loginForm.controls; }

  constructor(private loginService: LoginService,
    private router: Router,
    private userInfoService: UserInfoService,
    private storageService: StorageService,
    private alertService: AlertService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]]
    }
    );
  }

  public onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid)
      return;

    var data: any = {
      "email": this.f.email.value.trim()
    }

    this.loginService.forgetPassword(data).subscribe((res: any) => {
      if (res.success) {
        this.router.navigate(['/login']);
      }
    })
  }

  onClickBack() {
    this.router.navigate(['/login']);
  }
}
